export default __webpack_public_path__ + "static/button_apple-music-07335b929c0f5e95540d03c370f2cf35.png";